import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { Content } from '@radix-ui/react-accordion';

const slideDown = keyframes`
  from {
    opacity: 0;
    height: 0;
  }
  to {
    opacity: 1;
    height: var(--radix-accordion-content-height);
  }
`;

const slideUp = keyframes`
  from {
    opacity: 1;
    height: var(--radix-accordion-content-height);
  }
  to {
    opacity: 0;
    height: 0;
  }
`;

export const StyledAccordionContent = styled(Content)`
  &[data-state='open'] {
    animation: ${slideDown} 0.15s ease-in-out;
  }

  &[data-state='closed'] {
    animation: ${slideUp} 0.15s ease-in-out;
  }
`;
